import "../styles/global.css";
function Booking() {
    return (
        <div className="party-form-container">
        <h2>Book Our Party Hall</h2>
        <form className="party-form">
          <label>
            Name:
            <input type="text" placeholder="Your Name" required />
          </label>
          
          <label>
            Email:
            <input type="email" placeholder="you@example.com" required />
          </label>
      
          <label>
            Phone:
            <input type="tel" placeholder="9876543210" required />
          </label>
      
          <label>
            Occasion:
            <select required>
              <option value="">Select Occasion</option>
              <option>Birthday</option>
              <option>Engagement</option>
              <option>Baby Shower</option>
              <option>Anniversary</option>
              <option>Other</option>
            </select>
          </label>
      
          <label>
            Date:
            <input type="date" required />
          </label>
      
          <label>
            Number of Guests:
            <input type="number" min="1" max="200" placeholder="e.g., 50" required />
          </label>
      
          <label>
            Special Requests:
            <textarea placeholder="Any specific requests or notes..." rows="4"></textarea>
          </label>
      
          <button type="submit">Submit Booking</button>
        </form>
      </div>
      
    )
}

export default Booking;